module.exports = __webpack_public_path__ + "static/img/a.40f44ec0.png";